import { attach, createEvent, sample, split } from 'effector'
import { delay } from 'patronum'

import type { PortalProfile } from '@portal/portal-api'

import { checkShowTime, createProfileLocalStore } from './lib'
import { AccountNotProtectedDialog } from './ui/account-not-protected-dialog'
import { ProtectAccountDialog } from './ui/protect-account-dialog'

export const accountProtectionCheckCalled = createEvent<PortalProfile>()

const showProtectAccountDialogFx = attach({ effect: ProtectAccountDialog.model.showFx })
const showAccountNotProtectedDialogFx = attach({ effect: AccountNotProtectedDialog.model.showFx })

const $protectAccountDialogShowTime = createProfileLocalStore(0, 'email_bind_dialog_show_time').on(
    showProtectAccountDialogFx.done,
    () => Date.now()
)
const $accountNotProtectedShowTime = createProfileLocalStore(0, 'verify_email_dialog_show_time').on(
    showAccountNotProtectedDialogFx,
    () => Date.now()
)

const accountProtectionLoaded = sample({
    // we have to use `delay` to allow stores to pick up their values from local storage. See createProfileLocalStore
    clock: delay({ source: accountProtectionCheckCalled, timeout: 0 }),
    source: {
        protectAccountDialogLastShowTime: $protectAccountDialogShowTime,
        emailNotVerifiedDialogShowTime: $accountNotProtectedShowTime,
    },
    fn: (showTime, profile) => ({ ...showTime, profile }),
})

const account = split(accountProtectionLoaded, {
    new: ({ profile }) => profile.isNewAccount ?? false,
    emailEmpty: ({ profile, protectAccountDialogLastShowTime }) =>
        profile.email === '' && checkShowTime(protectAccountDialogLastShowTime),
    emailNotVerified: ({ profile, emailNotVerifiedDialogShowTime }) => {
        if (profile.email && profile.emailNeedVerify) {
            return checkShowTime(emailNotVerifiedDialogShowTime)
        }

        return false
    },
})

// NOTE: кулдаун на сутки для новичков (зарегались меньше минуты назад)
sample({
    clock: account.new,
    fn: () => Date.now(),
    target: [$protectAccountDialogShowTime, $accountNotProtectedShowTime],
})

sample({
    clock: account.emailEmpty,
    fn: () => ({}),
    target: showProtectAccountDialogFx,
})

sample({
    clock: account.emailNotVerified,
    fn: ({ profile }) => ({ email: profile.email }),
    target: showAccountNotProtectedDialogFx,
})
